webpackJsonp([60244956117622],{

/***/ 1504:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"PaymentReasonInput","kind":"INPUT_OBJECT","type":"OBJECT","fields":[{"defaultValue":null,"description":null,"name":"isActive","type":{"kind":"SCALAR","name":"Boolean","ofType":null}},{"defaultValue":null,"description":null,"name":"name","type":{"kind":"SCALAR","name":"String","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---input-object-payment-reason-input-b08b6b865048134f9e33.js